import * as ls from '@/services/localStorage';
import PopupNg from '@/ui/PopupNg';
import { isNativeCasinoGameSession } from '@/casinovegas/nativeCasinoGameSession';

export function initInformationDutyOverlay(db) {
    if (!db.get('loggedIn') || !window.INITIAL_DATA.informationDutyArticle || isNativeCasinoGameSession()) {
        ls.removeKey('information-duty-elapsed');
        return db;
    }
    const elapsed = ls.getObject('information-duty-elapsed') || 0;
    if (elapsed < 5) {
        return db.update(PopupNg.updater.open('information-duty', { blocking: true }, 1000));
    }
    return db;
}
